<section class="section section--finalInstructions">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form class="form full__height">
          <div class="content__main">
            <article class="mainInfo">
              <h1 class="pb-10">¡Ahora ve a la tienda!</h1>
              <p>Te hemos enviado el siguiente <strong>QR</strong> a tu <strong>Whatsapp</strong>. {{ 'Dile al vendedor que realizaste un crédito web y muéstrale el QR.' | termReplace }}</p>
            </article>

            <article class="finalInstructions">
              <div class="qr-code" [style.visibility]="showQr ? 'visible' : 'hidden'">
                <div class="qr-code__img">
                  <qrcode [qrdata]="requestId" [width]="300" [errorCorrectionLevel]="'M'" (qrCodeURL)="onChangeURL($event)"></qrcode>
                </div>
              </div>

              <div class="storeList__details pt-10">
                <div class="subtitle mb-10">
                  <h2>Detalle</h2>
                </div>
                <ul>
                  <li>
                    <h3>Monto máximo:</h3>
                    <span>
                      {{ currency}} <strong>{{ storeV3.preApprovalAmount }}</strong>
                    </span>
                  </li>

                  <li>
                    <h3>Abono mínimo:</h3>
                    <span>
                      <strong>{{ storeV3.selectedOffice?.min_installment ?? 50 }}</strong>%
                    </span>
                  </li>
                </ul>
              </div>
            </article>
          </div>

          <div class="content__footer content__footer--flex content__footer--invertOrder">
            <button pButton pRipple class="p-button-secondary p-button-raised p-button-rounded p-button-spaced w-full" (click)="onBackToStoresList()">
              <span class="p-button-label">Seleccionar otra tienda</span>
              <span class="p-button-icon p-button-icon-right p-button-icon-custom" aria-hidden="true">
                <app-store-v2-icon></app-store-v2-icon>
              </span>
            </button>
            <button pButton pRipple label="Regresar a KrdYa" icon="pi pi-angle-left" iconPos="left" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="onBackToKrdya()"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
